import React from 'react';
import { Info } from 'lucide-react';

interface TooltipProps {
  text: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export default function Tooltip({ text, position = 'top', className = '' }: TooltipProps) {
  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  const arrowClasses = {
    top: 'top-full left-1/2 -translate-x-1/2 border-t-slate-900 dark:border-t-slate-950',
    bottom: 'bottom-full left-1/2 -translate-x-1/2 border-b-slate-900 dark:border-b-slate-950',
    left: 'left-full top-1/2 -translate-y-1/2 border-l-slate-900 dark:border-l-slate-950',
    right: 'right-full top-1/2 -translate-y-1/2 border-r-slate-900 dark:border-r-slate-950',
  };

  return (
    <span className={`group relative inline-block ml-1.5 cursor-help align-middle select-none ${className}`}>
      <Info className="w-3.5 h-3.5 text-slate-400 dark:text-slate-500 hover:text-blue-500 dark:hover:text-blue-400 transition-colors" />
      <span className={`pointer-events-none absolute ${positionClasses[position]} w-52 p-2.5 bg-slate-900 dark:bg-slate-950 text-white dark:text-slate-100 text-[10.5px] font-semibold rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-150 shadow-xl border border-slate-800 dark:border-slate-900 text-center leading-normal z-[9999] whitespace-normal break-words`}>
        {text}
        <span className={`absolute border-4 border-transparent ${arrowClasses[position]}`} />
      </span>
    </span>
  );
}
